.rdo-overlay{background-color:#fff9;height:100%;left:0;position:absolute;top:0;width:100%;z-index:100}
/*# sourceMappingURL=overlay.component-EYWO3EBH.css.map */
